import Search from "@core/components/Search";
import { SearchFieldAttr } from "@core/interfaces";
import Table from "@core/components/Table";
import { Tag } from "antd";
import { TranslateFn } from "@core/hooks/useTranslate";
import { name as identity } from "@modules/Members/reducers/members";
import membersApi from "@modules/Members/services/members";
import moment from "moment";
import useDebounce from "@core/hooks/useDebounce";
import { useState } from "react";

interface Props {
  t: TranslateFn;
}

interface INation {
  _id: string;
  name: string;
}

const ChartMemberInfo = ({ t }: Props) => {
  /* State */
  const [filters, setFilters] = useState<string>("");
  const [defaultSorter, setDefaultSorter] = useState<string>("");
  const [sorterRole, setSorterRole] = useState<number>(-1);
  const debouncedSearchTerm = useDebounce(filters, 500);
  const [currentId] = useState<any>(null);
  const [visible, setVisible] = useState<boolean>(false);

  const columns = [
    {
      title: t("table:members:numbers"),
      dataIndex: "_id",
      width: 10,
      render: (text: string, record: any, index: number) => (
        <span key={record._id}>{index + 1}</span>
      ),
    },
    {
      title: t("table:content:title-description"),
      dataIndex: "userEmail",
      fixed: "left",
      width: 40,
    },
    {
      title: t("table:members:member-name"),
      dataIndex: "userName",
      fixed: "left",
      width: 20,
    },
    {
      title: t("table:members:register-date"),
      dataIndex: "createdAt",
      width: 20,
      render: (createdAt: string) => (
        <>{moment(createdAt).format("YYYY.MM.DD")}</>
      ),
    },
    {
      title: t("table:members:date-of-birth"),
      dataIndex: "userDOB",
      width: 20,
      render: (userDOB: string) => (
        <>{userDOB && moment(userDOB).format("YYYY.MM.DD")}</>
      ),
    },
    {
      title: t("table:members:gender"),
      dataIndex: "userGender",
      width: 20,
    },
    {
      title: t("table:members:nationality"),
      dataIndex: "nation",
      width: 20,
      render: (nation: INation) => `${nation?.name ?? ""}`,
    },
    {
      title: t("table:members:role"),
      dataIndex: "userRole",
      width: 20,
      render: (role: number) => (
        <Tag color={role === 1 ? "blue" : "red"}>
          {role === 1 ? "User" : "Admin"}
        </Tag>
      ),
    },
  ];

  const onSearch = (values: any, type: string) => {
    if (type === "selector") return setDefaultSorter(values);
    else if (type === "text") return setFilters(values);
    else if (type === "selector-role") return setSorterRole(values);
  };

  const fields: SearchFieldAttr[] = [
    {
      label: t("common:title"),
      name: "title",
      opt: "$like",
      type: "text",
      placeholder: t("search:text:placehoder"),
    },
    {
      label: t("common:title"),
      name: "type",
      opt: "$like",
      type: "selector-role",
      data: [
        {
          value: -1,
          label: t("search:selector:all"),
        },
        {
          value: 0,
          label: t("search:selector:admin"),
        },
        {
          value: 1,
          label: t("search:selector:user"),
        },
      ],
      placeholder: t("search:selector:placehoder:role"),
    },
    {
      label: t("common:title"),
      name: "type",
      opt: "$like",
      type: "selector",
      data: [
        {
          value: "userName",
          label: t("search:selector:name"),
        },
        {
          value: "createdAt",
          label: t("search:selector:date-of-registration"),
        },
      ],
      placeholder: t("search:selector:placehoder"),
    },
  ];

  return (
    <div className="table-member-list">
      <Search
        column={2}
        fields={fields}
        title={t("common:filter:title-store")}
        onSearch={onSearch}
      />

      {/* <Table
        scroll={{x: 800,y: 1000}}
        columns={columns}
        identity={identity}
        api={membersApi}
        filters={debouncedSearchTerm}
        defaultSorter={defaultSorter}
        sorterRole={sorterRole}
        currentId={currentId}
        modalVisible={visible}
        setVisible={setVisible}
      /> */}
    </div>
  );
};

export default ChartMemberInfo;
